import { AxiosResponse } from 'axios';
import { call } from 'redux-saga/effects';
import { takeEveryAsync } from 'saga-toolkit';
import request from 'utils/request';
import {
  registerUserAction,
  loginUserAction,
  getBillingInfoAction,
  refreshTheAccesTokenAction,
} from './index';
import { responseBody } from 'utils/parseResponse';

function* registerUserSaga({ meta: { arg: body } }) {
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body,
  };

  try {
    const response: AxiosResponse = yield call(
      request,
      '/user/login_after_register',
      options,
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    return {
      status: error.response.status,
      data: error.response.data.error[0].message,
    };
  }
}

function* loginUserActionSaga({ meta: { arg: body } }) {
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body,
  };

  try {
    const response: AxiosResponse = yield call(request, '/user/login', options);

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    return {
      status: error.response.status,
      data: error.response.data.error.message,
    };
  }
}

function* getBillingInfoActionSaga() {
  const options = {
    method: 'GET',
  };

  const response: AxiosResponse = yield call(
    request,
    '/user/billing_info',
    options,
  );

  return responseBody(response);
}

function* refreshTheAccesTokenActionSaga({
  meta: {
    arg: { accessToken, refreshToken },
  },
}) {
  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: {
      refresh_token: refreshToken.toString(),
    },
  };

  try {
    const response: AxiosResponse = yield call(
      request,
      '/user/refresh',
      options,
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    return {
      status: error.response.data.error.error_code,
    };
  }
}

export function* userSaga() {
  yield takeEveryAsync(registerUserAction.type, registerUserSaga);
  yield takeEveryAsync(loginUserAction.type, loginUserActionSaga);
  yield takeEveryAsync(
    refreshTheAccesTokenAction.type,
    refreshTheAccesTokenActionSaga,
  );
  yield takeEveryAsync(getBillingInfoAction.type, getBillingInfoActionSaga);
}
